export default __webpack_public_path__ + "7e5c8b8737852e385eaa4d4f68bc7210.svg";